import { styled } from 'styled-components';

import Button from '../Button';

export const ButtonCancel = styled(Button)`
  color: var(--color-text);
  display: block;
  font-size: var(--font-baseline);
  margin: 0 var(--spacing-tiny);
  padding: var(--spacing-tiny);

  &:disabled {
    background-color: var(--color-button-disabled);
    border-color: var(--color-button-disabled);
    color: var(--color-text-alt);

    /* unsupported on iOS, but doesn't matter since that's touch input anyway */
    /* stylelint-disable-next-line plugin/no-unsupported-browser-features */
    cursor: not-allowed;
  }
`;
